import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { RADIUS } from 'src/theme/ui-tokens';

import { CM, PUBLIC_TEXT } from '../constants/blog-layout';

// ----------------------------------------------------------------------

/** 글 끝의 주제 줄 — 위에 선 하나 · 옅은 알약. 주제가 없으면 안 그린다 */
export function PostTags({ tags }: { tags: string[] }) {
  if (!tags.length) return null;
  return (
    <Stack direction="row" flexWrap="wrap" useFlexGap spacing={1} sx={{ mt: 4, pt: 2.5, borderTop: `1px solid ${CM.border}` }}>
      {tags.map((tag) => (
        <Typography
          key={tag}
          sx={{ fontSize: PUBLIC_TEXT.eyebrow.fontSize, fontWeight: 600, color: CM.textMuted, bgcolor: CM.bgMuted, borderRadius: RADIUS.pill, px: 1.5, py: 0.5 }}
        >
          {tag}
        </Typography>
      ))}
    </Stack>
  );
}
